export default __webpack_public_path__ + "static/anzeige-stk-fe96b2d282b2de3943f020b7b1f554fd.jpg";